<template>
  <div :class="classObj" class="app-wrapper" :style="{'--current-color': theme}">
<!--    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>-->
    <sidebar v-if="!sidebar.hide" class="sidebar-container"/>
    <div :class="{hasTagsView:needTagsView,sidebarHide:sidebar.hide}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
<!--       菜单位置指示栏 -->
        <navbar @setLayout="setLayout"/>
        <!--       打开过的菜单栏 -->
        <tags-view v-if="needTagsView"/>
      </div>
      <app-main/>
<!--      <settings ref="settingRef"/>-->
    </div>
  </div>
</template>

<script>
import { AppMain, Navbar,  Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import variables from '@/assets/styles/variables.scss'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    // Settings,
    Sidebar,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      theme: state => state.settings.theme,
      sideTheme: state => state.settings.sideTheme,
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        // mobile: this.device === 'mobile'
        mobile: false
      }
    },
    variables() {
      return variables
    }
  },
  watch: {
    // 监听 $route 的变化
    $route(to, from) {
      // 当路由发生变化时（例如，从新增页面跳转回来），重新加载数据
      this.initGlobalData();
    }
  },
  methods: {
    // handleClickOutside() {
    //   this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    // },
    setLayout() {
      this.$refs.settingRef.openSetting()
    },
    async initGlobalData() {
      try {
        // 加载仓库数据
        await this.$store.dispatch('common/loadStore');
        console.log('仓库数据加载完成', this.$store.state.common.storeList);
        await this.$store.dispatch('common/loadLogisticsProduct');
        console.log('物流产品数据加载完成', this.$store.state.common.logisticsProductList);
       /* // 加载运输方式数据
        await this.$store.dispatch('common/loadTransportation');
        console.log('运输方式数据加载完成');

        // 加载平台数据
        await this.$store.dispatch('common/loadPlatform');
        console.log('平台数据加载完成');

        // 加载分区类型数据
        await this.$store.dispatch('common/loadPartitionType');
        console.log('分区类型数据加载完成', this.$store.state.common.partitionTypeList);
        // 加载仓库数据
        await this.$store.dispatch('common/loadStore');
        console.log('仓库数据加载完成', this.$store.state.common.storeList);
        // 加载库位类型数据
        await this.$store.dispatch('common/loadLocationType');
        console.log('库位类型数据加载完成', this.$store.state.common.locationTypeList);
        // 加载订单数据
        await this.$store.dispatch('common/loadOrderList');
        console.log('订单数据加载完成', this.$store.state.common.orderList);
        //加载物流渠道数据
        await this.$store.dispatch('common/loadLogisticsChannel');
        console.log('物流渠道数据加载完成', this.$store.state.common.logisticsChannelList);
        //加载物流产品数据
        await this.$store.dispatch('common/loadLogisticsProduct');
        console.log('物流产品数据加载完成', this.$store.state.common.logisticsProductList);
        await this.$store.dispatch('common/loadLogisticsWeightTemplate');
        console.log('物流重量模板数据加载完成', this.$store.state.common.LogisticsWeightTemplateList);
        await this.$store.dispatch('common/loadShippingPartitionScheme');
        console.log('运输分区方案数据加载完成', this.$store.state.common.ShippingPartitionSchemeList);
        await this.$store.dispatch('common/loadFeeType');
        console.log('运费类型数据加载完成', this.$store.state.common.FeeTypeList);*/
        //加载物流公司数据
      } catch (error) {
        console.error('全局数据初始化失败:', error);
      } finally {

      }
    }
  },
  created() {
    this.initGlobalData()
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixin.scss";
@import "~@/assets/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$base-sidebar-width});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.sidebarHide .fixed-header {
  width: 100%;
}

.mobile .fixed-header {
  width: 100%;
}
</style>
